angular.module( 'acme.view.application.resources.facilities', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.resources.facilities.assign',
  'acme.view.application.resources.facilities.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var resourcesFacilities = {
        name: 'application.resources.facilities',
        url: '/facilities',
        abstract: true,
        views: {
          "subview-main": {
            templateUrl: 'views/application/views/resources/facilities/facilities.tpl.html'
          }
        }
      },
      resourcesFacilitiesList = {
        name: 'application.resources.facilities.list',
        url: '',
        views: {
          "subview-main": {
            controller: 'ResourcesFacilitiesController',
            templateUrl: 'views/application/views/resources/facilities/facilitiesList.tpl.html'
          }
        },
        data: {
          pageTitle: 'Facilities Manager',
          rule: function(permits) {
            // Allow if state is not in exclusions array
            return (permits.indexOf('application.resources.facilities.assign') !== -1);
          }
        }
      };

    $stateProvider
      .state(resourcesFacilities)
      .state(resourcesFacilitiesList);
});
